//Core
import {FC} from "react";
//Styles
import {
    PixelStatusTooltipButton,
    PixelStatusTooltipContainer,
    PixelStatusTooltipText
} from "./PixelStatusTooltip.styles";
//Hooks
import {usePixelStatusTooltip} from "./usePixelStatusTooltip";
//Images
import {PixelStatusSvg} from "../SideBarButtons.data";

export const PixelStatusTooltipTitle: FC = () => {
    const {pixelStatus, goToPixel, pixelStatusColor, pixelStatusText} = usePixelStatusTooltip();

    return (
        <PixelStatusTooltipContainer>
            {PixelStatusSvg[pixelStatus](pixelStatusColor)}
            <PixelStatusTooltipText>{pixelStatusText}</PixelStatusTooltipText>
            <PixelStatusTooltipButton onClick={goToPixel}>{'Click to details'}</PixelStatusTooltipButton>
        </PixelStatusTooltipContainer>
    )
}